<template lang="html">
<div>
  <el-button type="primary" @click="$router.push({name:'添加车展活动', query: { businessId: searchInfo.businessId ,carShowId: searchInfo.carShowId}})">上架新活动</el-button>

  <list-template ref="list-template" :queryParams="searchInfo" actionUrl="carShow/business/findBusinessActivity.action">
    <template slot="item" scope="scope">
      <el-card class="basic-margin" v-for="data in scope.datas">
        <el-row>
          <el-col :span="20">
            <h4><b>{{data.name}}</b></h4>
            <div>活动周期：{{data.startTime | dateFormat}} 至 {{data.endTime | dateFormat}}</div>
            <div style="color:#999999">创建时间：{{data.createTime | dateTimeFormat}}</div>
          </el-col>

          <el-col :span="4">
            <el-button v-confirm :confirm-data="data" @onConfirm="up" confirm-text="确认顶置该活动？" type="text">顶置活动</el-button>
            <el-button @click="$router.push({name:'保存车展活动', query: { id: data.id }})" type="text">修改</el-button>
            <el-button v-if="data.del==0" v-confirm :confirm-data="data" @onConfirm="deleteActivity" confirm-text="确认删除活动？" type="text">删除</el-button>
            <el-button v-else v-confirm :confirm-data="data" @onConfirm="recoveryActivity" confirm-text="确认恢复活动？" type="text">恢复</el-button>
          </el-col>
        </el-row>
      </el-card>
    </template>
  </list-template>
</div>
</template>

<script>
import ListTemplate from '@/components/ListTemplate'
import CarExhibitionModel from '@/framework/models/CarExhibitionModel'
export default {
  components: {
    ListTemplate
  },
  data: function () {
    return {
      searchInfo: {
        businessId: null,
        carShowId: null
      }

    }
  },
  created: function () {
    let params = this.$route.query

    this.searchInfo.businessId = params.businessId
    this.searchInfo.carShowId = params.carShowId
  },
  methods: {
    up: function (data) {
      let _this = this
      let params = {
        activityId: data.id
      }

      let listener = {
        success: function (dataInfo) {
          _this.$message.success('顶置成功!')
          _this.$refs['list-template'].search()
        }
      }
      CarExhibitionModel.upActivity(_this, params, listener)
    },
    deleteActivity: function (data) {
      let _this = this
      let params = {
        activityId: data.id
      }

      let listener = {
        success: function (dataInfo) {
          _this.$message.success('删除成功!')
          _this.$refs['list-template'].search()
        }
      }
      CarExhibitionModel.deleteActivity(_this, params, listener)
    },
    recoveryActivity: function (data) {
      let _this = this
      let params = {
        activityId: data.id
      }

      let listener = {
        success: function (dataInfo) {
          _this.$message.success('恢复成功!')
          _this.$refs['list-template'].search()
        }
      }
      CarExhibitionModel.recoveryActivity(_this, params, listener)
    }

  }
}
</script>

<style lang="css">
</style>
